import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const getCompleteSurveyAction = createAsyncThunk(
    'get-complete-survey',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/pwa/api/get-completed-surveys`,{...data})
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getCompleteSurveySlice = createSlice({
    name: 'get-complete-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getCompleteSurveyAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(getCompleteSurveyAction.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(getCompleteSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const getCompleteSurveyReducer = getCompleteSurveySlice.reducer